export enum DCUIThemingTabTypes {
    THEME = "dcui-theme",
    START_PAGE = "dcui-start-page",
    DL_FRONT = "dcui-dl-front",
    DL_BACK = "dcui-dl-back",
    ID_FRONT = "dcui-id-front",
    ID_BACK = "dcui-id-back",
    PASSPORT = "dcui-passport",
    SELFIE = "dcui-selfie",
    CAPTURE_COMPLETE = "dcui-capture-complete",
    ERROR = "dcui-error",
    CUSTOM_CSS = "custom-css",
    TEXT_CONTENT = "dcui-text-content"
}